var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.fontFamily,staticStyle:{"text-align":"center"},style:({ color: _vm.color, fontWeight: _vm.fontWeight, fontSize: _vm.fontSize, margin: _vm.margin })},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }